import React, {useEffect, useState, useRef} from "react"
import PropTypes, { element } from 'prop-types'
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Button,
  Alert,
  Spinner
} from "reactstrap"
import Select from "react-select"
import { useSelector, useDispatch } from "react-redux"
import { addNewItem as onAddNewItem } from "store/products/actions"
import { getAllCustomers as onGetAllCustomers } from "store/products/actions"

import { editItemDirect as onEditItemDirect } from "helpers/backend_helper"
import { addNewItemDirect as onAddItemDirect } from "helpers/backend_helper"
import { showSuccessToast } from "helpers/function_helper"
import { getStateList } from "helpers/backend_helper"

const AddNewCustomer = props => {
  const dispatch = useDispatch()
  const nameInputRef = useRef(null);
  
  const [validation, setValidation] = useState({
    customerName: null,
  })
  const [showLoading, setShowLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  
  const [customerName, setCustomerName] = useState('')
  const [customerAddress, setCustomerAddress] = useState('')
  const [customerMobile, setCustomerMobile] = useState('')
  const [customerPhone, setCustomerPhone] = useState('')
  const [customerEmail, setCustomerEmail] = useState('')
  const [customerGSTIN, setCustomerGSTIN] = useState('')
  const [customerState, setCustomerState] = useState()
  const [stateList, setStateList] = useState([])

  useEffect(() => {
    getStates()
  }, [])

  async function getStates() {
    getStateList().then(result => {
      setStateList(result)
      if(result && result.length > 0){
        result.forEach(element =>{
          if(element.name == 'KERALA'){
            setCustomerState(element)
          }
        })
      }
    })
  }

  useEffect(() => {
    nameInputRef.current.focus();
    setTimeout(() => {
      document.getElementById('inp-name').focus();
      document.getElementById('inp-name').select();
    }, 250);
    if(props.enteredText != ''){
      setCustomerName(props.enteredText)
    }
  }, [props.enteredText])

  useEffect(() => {
    if(props.isEdit){
      //console.log('props.detailsForEdit:'+JSON.stringify(props.detailsForEdit))
      setCustomerName(props.detailsForEdit.name)
      setCustomerAddress(props.detailsForEdit.address)
      setCustomerMobile(props.detailsForEdit.mobile)
      setCustomerPhone(props.detailsForEdit.phone)
      setCustomerEmail(props.detailsForEdit.email)
      setCustomerGSTIN(props.detailsForEdit.gstin)
      let foundState = false;
      if(stateList && stateList.length > 0){
        stateList.forEach(element =>{
          if(element.id == props.detailsForEdit.stateid){
            setCustomerState(element)
            foundState = true;
          }
        })
      }

      if(!foundState){
        setCustomerState(null)
      }

    }
  }, [props.detailsForEdit])

  function isNumber(num){
    if(Number(num) || num == 0){
      return true;
    }
    else{
      return false;
    }
  }

  const onChangeValidation = (fieldName, value) => {
    const modifiedV = { ...validation }
    if (value !== "") {
      modifiedV[fieldName] = true
    } else {
      modifiedV[fieldName] = false
    }
    setValidation(modifiedV)
  }

  function validateForm() {
    const modifiedV = { ...validation }
    let formValid = true;
    if(customerName && customerName != ""){
      modifiedV["customerName"] = true
    }
    else{
      modifiedV["customerName"] = false
      formValid = false
    }

    if(customerState){
      modifiedV["customerState"] = true
    }
    else{
      modifiedV["customerState"] = false
      formValid = false
    }

    setValidation(modifiedV)
    return formValid
  }

  async function addItem() {
    const formValid = validateForm()
    if(formValid){
      setShowLoading(true)
      const response = await onAddItemDirect({
        'name': customerName,
        'address' : customerAddress,
        'mobile' : customerMobile,
        'phone' : customerPhone,
        'email' : customerEmail,
        'gstin': customerGSTIN,
        'stateid' : customerState.id,
        'statecode' : customerState.code,
        'statename' : customerState.name,
      }, 'Customer')

      setShowLoading(false)
      if(response.status == 'success'){
        dispatch(onGetAllCustomers(false))
        props.newlyAddedValue(response.confirmation_code)
        showSuccessToast('Added Successfully!!!')
      }
      else if(response.status == 'failure'){
        setErrorMessage(response.errorResponse)
      }
    }
  }

  async function editItem() {
    const formValid = validateForm();
    if(formValid){
      setShowLoading(true)
      const response = await onEditItemDirect({
          'value': props.detailsForEdit.value,
          'name': customerName,
          'address' : customerAddress,
          'mobile' : customerMobile,
          'phone' : customerPhone,
          'email' : customerEmail,
          'gstin' : customerGSTIN,
          'stateid' : customerState.id,
          'statecode' : customerState.code,
          'statename' : customerState.name,
        }, 'Customer')

      setShowLoading(false)

      if(response.status == 'success'){
        dispatch(onGetAllCustomers(false))
        props.newlyAddedValue(response.confirmation_code)
        showSuccessToast('Edited Successfully!!!')
      }
      else if(response.status == 'failure'){
        setErrorMessage(response.errorResponse)
      }
    }
  }

  return (
    <React.Fragment>
      <div className=" ">
        <Container fluid={true}>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="wizard clearfix">
                    <Form>
                      {errorMessage !== '' ? <Alert color="danger">{errorMessage}</Alert> : null}
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="inp-name">
                              Name
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="inp-name"
                              maxLength="150"
                              ref={nameInputRef}
                              value={customerName}
                              autoFocus={true}
                              onChange={event => {
                                onChangeValidation("customerName", event.target.value.trim())
                                setCustomerName(event.target.value)
                              }}
                              invalid={
                                validation["customerName"] !== true &&
                                validation["customerName"] !== null
                              }
                            />
                            {(validation["customerName"] === false) &&
                              <div className="custom-error">
                                Please enter the Customer Name
                              </div>
                            }
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="inpname">
                              Address
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="inpname"
                              maxLength="200"
                              value={customerAddress}
                              onChange={event => {
                                onChangeValidation("customerAddress", event.target.value.trim())
                                setCustomerAddress(event.target.value)
                              }}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="inpname">
                              State
                            </Label>
                            <Select
                              value={customerState}
                              onChange={(e) => {
                                setCustomerState(e)
                                onChangeValidation("customerState", e.value)
                                //setCategoryName(e.value)
                              }}
                              options={stateList}
                              classNamePrefix="select2-selection"
                              isLoading={false}
                              getOptionLabel={option=>option.name + ' - ' +option.code}
                              getOptionValue={option=>option.id}
                              id="customerstate"
                            />
                            {(validation["customerState"] === false) &&
                              <div className="custom-error">
                                Please select the State
                              </div>
                            }
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="inpmobile">
                              Mobile
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="inpmobile"
                              maxLength="10"
                              value={customerMobile}
                              onChange={event => {
                                if(isNumber(event.target.value)){
                                  onChangeValidation("customerMobile", event.target.value.trim())
                                  setCustomerMobile(event.target.value)
                                }
                              }}
                            />
                          </div>
                        </Col>
                      </Row>
                      {/*<Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="inpphone">
                              Phone
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="inpphone"
                              maxLength="20"
                              value={customerPhone}
                              onChange={event => {
                                onChangeValidation("customerPhone", event.target.value.trim())
                                setCustomerPhone(event.target.value)
                              }}
                            />
                          </div>
                        </Col>
                      </Row>*/}

                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="inpemail">
                              Email
                            </Label>
                            <Input
                              type="email"
                              className="form-control"
                              id="inpemail"
                              maxLength="100"
                              value={customerEmail}
                              onChange={event => {
                                onChangeValidation("customerEmail", event.target.value.trim())
                                setCustomerEmail(event.target.value)
                              }}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="inpcgstin">
                              GSTIN
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="inpcgstin"
                              maxLength="100"
                              value={customerGSTIN}
                              onChange={event => {
                                onChangeValidation("customerGSTIN", event.target.value.trim())
                                setCustomerGSTIN(event.target.value)
                              }}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="d-inline-block float-end">
                            {showLoading && <Spinner style={{ width: '2.2rem', height: '2.2rem' }} className="me-3 mt-3" color="primary" />}
                            {props.isEdit === true ? 
                            <Button
                              color="info"
                              className="btn w-lg mt-3 float-end btn-info "
                              onClick={() => {
                                editItem()
                              }}
                              disabled={showLoading}
                              >
                                SAVE
                            </Button>
                            :
                            <Button
                              color="info"
                              className="btn w-lg mt-3 float-end btn-info "
                              onClick={() => {
                                addItem()
                              }}
                              disabled={showLoading}
                              >
                                ADD
                            </Button>
                            }
                            </div>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

AddNewCustomer.propTypes = {
  newlyAddedValue: PropTypes.func,
  detailsForEdit: PropTypes.any,
  isEdit:PropTypes.bool,
  enteredText:PropTypes.any,
}

export default AddNewCustomer
